import { IMAGES } from 'src/assets'
import i18n from 'src/i18n'
import { EmptyStateProps } from './emptyState.types'

const EmptyState = ({ title, description }: EmptyStateProps) => {
  return (
    <div className="_d-flex _flex-column _justify-content-center _align-items-center _text-center">
      <img src={IMAGES.EMPTY_STATE_COMMUNITIES} alt="community" />
      <p className="_text-4 _mt-5">{i18n.t(title)}</p>
      <p className="_text-3 _mt-2 _mb-5">{i18n.t(description)}</p>
    </div>
  )
}

export default EmptyState
